module.exports = __webpack_public_path__ + "img/home_icon_renwuzhongxin.c9e930f5.svg";